import { render, staticRenderFns } from "./InputPicCaptcha.vue?vue&type=template&id=2238e456&scoped=true&"
import script from "./InputPicCaptcha.vue?vue&type=script&lang=js&"
export * from "./InputPicCaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2238e456",
  null
  
)

export default component.exports